export enum UpDownThemeEnum {
  greenUpRedDown = 'greenUpRedDown',
  redUpGreenDown = 'redUpGreenDown',
}

export enum ThemeEnum {
  DARK = 'Dark',
  LIGHT = 'Light',
}
